// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-table-container {
  display: grid;
  grid-template-columns: 1fr 110px 160px 70px;
  overflow-y: auto;
  font-size: 13px;
  margin-top: 10px;
}
.chart-table-container .chart-table-header {
  border-top: 1px solid #DBE7F1;
  color: #6A8991;
  padding: 8px 0;
}
.chart-table-container .chart-table-row {
  border-top: 1px solid #DBE7F1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 30px;
  padding-top: 10px;
  cursor: default;
}
.chart-table-container .chart-table-row-header {
  color: #40A0C1;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/Charts/ChartTable/ChartTable.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AACD;AACC;EACC,6BAAA;EACA,cAAA;EACA,cAAA;AACF;AAEC;EACC,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAAF;AAGC;EACC,cAAA;EACA,iBAAA;AADF","sourcesContent":[".chart-table-container {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 110px 160px 70px;\n\toverflow-y: auto;\n\tfont-size: 13px;\n\tmargin-top: 10px;\n\n\t.chart-table-header {\n\t\tborder-top: 1px solid #DBE7F1;\n\t\tcolor: #6A8991;\n\t\tpadding: 8px 0;\n\t}\n\n\t.chart-table-row {\n\t\tborder-top: 1px solid #DBE7F1;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\theight: 30px;\n\t\tpadding-top: 10px;\n\t\tcursor: default;\n\t}\n\n\t.chart-table-row-header {\n\t\tcolor: #40A0C1;\n\t\tfont-weight: bold;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
